import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { entityErrorMessage } from '../lib/entityErrorMessage';
export function makeEntityHooks(descriptor) {
    const { key, list, upsert, remove, extraInvalidateKeys = [] } = descriptor;
    const invalidateExtras = (qc)=>{
        for (const k of extraInvalidateKeys){
            qc.invalidateQueries({
                queryKey: [
                    k
                ]
            });
        }
    };
    const useList = (req, opts)=>useQuery({
            queryKey: [
                key,
                'list',
                req
            ],
            queryFn: ()=>list(req),
            staleTime: 30000,
            enabled: opts?.enabled
        });
    const useUpsert = (opts)=>{
        const qc = useQueryClient();
        return useMutation({
            mutationFn: upsert,
            onSuccess: ()=>{
                qc.invalidateQueries({
                    queryKey: [
                        key
                    ]
                });
                invalidateExtras(qc);
                if (!opts?.silent) {
                    toast.success(`${key} saved`);
                }
            },
            onError: (err)=>{
                toast.error(entityErrorMessage(err, 'save', key));
            }
        });
    };
    const useDelete = ()=>{
        const qc = useQueryClient();
        return useMutation({
            mutationFn: remove,
            onSuccess: ()=>{
                qc.invalidateQueries({
                    queryKey: [
                        key
                    ]
                });
                invalidateExtras(qc);
                toast.success(`${key} deleted`);
            },
            onError: (err)=>{
                toast.error(entityErrorMessage(err, 'delete', key));
            }
        });
    };
    return {
        useList,
        useUpsert,
        useDelete
    };
}
